import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AdsService } from 'src/app/@core/services/ads.service';
import { ArticleService } from 'src/app/@core/services/article.service';
import { PagesService } from 'src/app/@core/services/pages.service';

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ArticleComponent implements OnInit, OnDestroy {
  id: any;
  article: any;
  articles: any = [];
  closeResult = '';
  referidos: any;
  configMark = [];
  query = '';
  keywords = '';
  keywordsArray = [];
  timer: any;
  search: string = null;
  bannerCategory: string = 'page_banner';
  bannerImages: any[] = [];

  public origin: any;

  constructor(
    private route: ActivatedRoute,
    private articlesService: ArticleService,
    private router: Router,
    private pageService: PagesService,
    private adsService: AdsService
  ) {}

  ngOnInit(): void {
    this.adsService
      .getBannerByCategory(this.bannerCategory)
      .subscribe((res) => {
        this.bannerImages = res;
      });
    this.router.routerState.root.queryParams.subscribe((res: any) => {
      this.search = res.query;
    });
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      this.getArticle();
    });

    this.route.queryParams
      .pipe(filter((params) => !!params))
      .subscribe((params) => {
        this.query = params.query;
        if (this.query) {
          this.configMark.push({
            query: this.query,
            className: 'query',
            filter: (node: any, term: string) => term?.length >= 4,
          });
        }
        this.keywords = params.keywords;
        if (!this.keywords) {
          return;
        } else {
          this.keywordsArray = this.keywords?.split(',');
          this.configMark.push({
            query: this.keywords?.split(','),
            className: 'keyword',
          });
        }
      });
  }

  ngOnDestroy(): void {
    /* if (this.timer) {
      this.timer = clearInterval();
    } */
  }

  goArticle(articleId: number) {
    const queryParams: any = {
      query: '',
      keywords: '',
    };
    if (this.query) {
      queryParams.query = this.query;
    }
    if (this.keywords) {
      queryParams.keywords = this.keywords;
    }
    this.router.navigate(['/noticias', articleId], { queryParams });
    /* this.timer = setInterval(() => {
      location.reload();
    }, 1000); */
  }

  getArticle() {
    this.articlesService.getArticle(this.id).subscribe(
      (response) => {
        this.article = response.article;
        this.getAllArticles(this.article.page_id);
        this.origin = this.pageService.getPage(this.article.page_id);
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getAllArticles(page: string) {
    this.articles = [];
    this.articlesService
      .getArticlesByParams({
        limit: 6,
        offset: 0,
        pages: page,
        query: this.query,
      })
      .subscribe(
        (articles) => {
          articles.forEach((article) => {
            if (article._id !== this.article._id) {
              return this.articles.push(article);
            } /* else {
              this.articles.push(article);
              const repeated = this.articles.find((a) => {
                return a._id === article._id;
              });
              this.articles.shift(repeated);
              console.log(repeated);
            } */
          });
        },
        (error) => {
          console.error(error);
        }
      );
  }
}
